import ReactGA from 'react-ga4';

// Initiera Google Analytics
export const initGA = (measurementId) => {
  if (measurementId) {
    ReactGA.initialize(measurementId);
    console.log('Google Analytics initialiserat med ID:', measurementId);
  } else {
    console.warn('Google Analytics Measurement ID saknas');
  }
};

// Spåra sidvisningar
export const trackPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

// Spåra events
export const trackEvent = (action, category = 'General', label = '', value = 0) => {
  ReactGA.event({
    action,
    category,
    label,
    value
  });
};

// Spåra produktklick
export const trackProductClick = (productName, productId, category = 'Product') => {
  trackEvent('click', category, `${productName} (${productId})`);
};

// Spåra affiliate-länkklick
export const trackAffiliateClick = (productName, productId) => {
  trackEvent('affiliate_click', 'Affiliate', `${productName} (${productId})`);
};

// Spåra sökningar (om du lägger till sökfunktion)
export const trackSearch = (searchTerm) => {
  trackEvent('search', 'Search', searchTerm);
};